module.exports = __webpack_public_path__ + "static/media/photo52.48506872.jpg";